module.exports = __webpack_public_path__ + "img/yl3073.b5a00d42.png";